import { StepResolverStrategy } from './step-resolver.strategy';
import { inject, Injectable } from '@angular/core';
import { Step } from '../../types';
import { Observable, of } from 'rxjs';
import { ApplicantStepDefinitionService } from '../step-definition';
import { Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({
  providedIn: 'root',
})
export class ApplicantStepResolverService implements StepResolverStrategy {
  private readonly applicantStepDefinitionService = inject(ApplicantStepDefinitionService);

  resolve(activeFlow: Flow): Observable<Step> {
    return of(this.applicantStepDefinitionService.getStepDefinition(activeFlow));
  }
}
